import CustomHeader from 'components/ReusableComponents/HeaderTitles'
import LoadingIndicator from 'components/ReusableComponents/LoadingIndicator'
import CompareAndPublish from 'features/PublishCampaign/CompareAndPublish'
import ContentVariants from 'features/PublishCampaign/ContentVariants'
import { getCampaignNameFromCategory } from 'main/campaignNamesAndDesc'
import { useEffect } from 'react'
import { useState } from 'react'
import { useParams } from 'react-router'
import campaignApi from 'services/api/campaign'

const PublishCampaign = () => {
  const [selectedContentId, setSelectedContentId] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const [response, setResponse] = useState()

  const { category } = useParams()

  useEffect(() => {
    campaignApi
      .compareDefault({ category })
      .then(response => {
        setResponse(response)
      })
      .finally(() => setIsLoading(false))
  }, [category])

  function publishContent() {
    const subsidiaryIds = response.readyToPublish
      .find(item => item.id === selectedContentId)
      .usedBy.map(item => item.id)

    const newContent = response.currentContent

    setIsLoading(true)

    campaignApi
      .publishCampaign({ subsidiaryIds, category, newContent })
      .then(() => campaignApi.compareDefault({ category }))
      .then(response => {
        setResponse(response)
      })
      .finally(() => {
        setSelectedContentId(null)
        setIsLoading(false)
      })
      .catch(() => {
        console.warn('Error while publishing campaign')
        setSelectedContentId(null)
        setIsLoading(false)
      })
  }

  const campaignName = getCampaignNameFromCategory(category)

  if (isLoading) {
    return <LoadingIndicator />
  }

  if (selectedContentId) {
    return (
      <>
        <CustomHeader title={`Publish "${campaignName}"`} width={900} />
        <CompareAndPublish
          previousContent={
            response.readyToPublish.find(item => item.id === selectedContentId).content
          }
          newContent={response.currentContent}
          usedBy={
            response.readyToPublish.find(item => item.id === selectedContentId).usedBy
          }
          onCancel={() => setSelectedContentId(null)}
          onConfirm={publishContent}
        />
      </>
    )
  }

  return (
    <>
      <CustomHeader title={`Publish "${campaignName}"`} width={900} />
      <ContentVariants
        readyToPublish={response.readyToPublish}
        alreadyPublished={response.alreadyPublished}
        previousContent={response.previousContent}
        currentContent={response.currentContent}
        setContentId={setSelectedContentId}
      />
    </>
  )
}

export default PublishCampaign
